var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.56494 2.0176C1.22945 1.77466 0.760538 1.84968 0.517598 2.18517C0.274657 2.52066 0.349683 2.98957 0.685172 3.23251L5.00006 6.35709V21.2587C5.00006 21.5471 5.16545 21.81 5.42545 21.9348C5.68546 22.0596 5.99401 22.0243 6.21907 21.8439L12.0001 17.2112L17.781 21.8439C18.0061 22.0243 18.3147 22.0596 18.5747 21.9348C18.8347 21.81 19.0001 21.5471 19.0001 21.2587V16.495L22.4352 18.9825C22.7707 19.2255 23.2396 19.1504 23.4825 18.8149C23.7255 18.4794 23.6504 18.0105 23.3149 17.7676L1.56494 2.0176ZM17.5001 15.4088L6.50006 7.44329V19.6965L11.531 15.6648C11.8051 15.4451 12.195 15.4451 12.4691 15.6648L17.5001 19.6965V15.4088Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25006 2.00006C6.83585 2.00006 6.50006 2.33585 6.50006 2.75006C6.50006 3.16427 6.83585 3.50006 7.25006 3.50006H17.2501C17.3881 3.50006 17.5001 3.61199 17.5001 3.75006V10.2501C17.5001 10.6643 17.8358 11.0001 18.2501 11.0001C18.6643 11.0001 19.0001 10.6643 19.0001 10.2501V3.75006C19.0001 2.78356 18.2166 2.00006 17.2501 2.00006H7.25006Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSlash);
export default __webpack_public_path__ + "static/media/bookmark-slash.6968f283.svg";
export { ForwardRef as ReactComponent };